// These should be overridden by the implementation
const errorHandler = {
  getHTTPErrorHandler: () => { },
};

export default errorHandler;
